import Vue from 'vue'
import { ActivityReservationsRequests } from '@/services/activityReservations.requests'
import { colonHourToMs } from '@/lib/helpers/HoursFormatter'
const activityReservationService = new ActivityReservationsRequests()
const state = {
  edited: {},
  lastReservation: null,
  attemptedReservation: null,
  modificationAlert: null,
}

const getters = {
  isUnsaved: (state) => !!Object.keys(state.edited).length,
  extendedRM: (state, getters, rootState) => {
    const extendedRM = rootState.activities.extendedActivity && localStorage.getItem('reservationMethodType')
      ? rootState.activities.extendedActivity.reservationMethods.find((extendedRM) => {
        return extendedRM.reservationMethod.type === localStorage.getItem('reservationMethodType')
      })
      : null
    return extendedRM || null
  },
  reservationMethod: (state, getters) => {
    return getters.extendedRM ? getters.extendedRM.reservationMethod : null
  },
  attendeeTypes: (state, getters) => {
    return getters.extendedRM ? getters.extendedRM.attendeeTypes : []
  },
  activityGroup: (state, getters) => {
    return getters.extendedRM ? getters.extendedRM.activityGroup : null
  },
  accountCurrencies: (state) => { try { return state.edited.account.currencies } catch { return [] } },
}

const actions = {
  makeReservation ({ state }, order) {
    return new Promise((resolve, reject) => {
      activityReservationService.makeReservation(state.edited, order).then(({ id }) => {
        state.lastReservation = id
        resolve(id)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  retryReservation ({ state }) {
    return new Promise((resolve, reject) => {
      activityReservationService.retryReservation(state.attemptedReservation).then(({ id }) => {
        resolve(id)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  cancelReservation ({ state }) {
    return new Promise((resolve, reject) => {
      const body = {
        ...state.edited,
        reason: state.edited.reason || null,
      }
      activityReservationService.cancelReservation(body).then(({ id }) => {
        resolve(id)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  requestModification ({ state }) {
    return new Promise((resolve, reject) => {
      const { date, slot, reason, id } = state.edited
      activityReservationService.requestModification({
        requestedDate: date,
        requestedTime: colonHourToMs(slot),
        reason: reason || null,
        id,
      }).then(({ id }) => {
        resolve(id)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}

const mutations = {
  setEdited (state, edited) {
    Vue.set(state, 'edited', edited)
  },
  setField (state, { field, value }) {
    if (field === 'nominal' || field === 'numeral') {
      Vue.set(state.edited, 'attendees', { [field]: value || [] })
    } else {
      Vue.set(state.edited, field, value)
    }
  },
  setAttemptedReservation (state, reservation) {
    state.attemptedReservation = reservation
  },
  reset (state) {
    state.edited = {}
  },
  resetLastReservation (state) {
    state.lastReservation = null
  },
  setModificationAlert (state, data) {
    state.modificationAlert = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
